import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgLawsuitMovements(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M19.093 70.413h14.26v5.32h-14.26v-5.32Z" fill="#007A5F" />
      <path d="M33.352 70.413h56.72v5.32h-56.72v-5.32Z" fill="#00664F" />
      <path
        d="M90.072 70.413v5.32h-56.72v-5.32h56.72Zm-55.12 3.72h53.52v-2.12h-53.52v2.12Z"
        fill="#00664F"
      />
      <path d="M26.381 59.146h44.362v11.267H26.381V59.146Z" fill="#78B441" />
      <path d="M70.743 59.146h32.955v11.267H70.743V59.146Z" fill="#599F40" />
      <path d="M107.341 65.857a.8.8 0 1 1 0 1.6H37.155a.8.8 0 1 1 0-1.6h70.186Z" fill="#0F172A" />
      <path d="M14.974 75.733h31.37v10.64h-31.37v-10.64Z" fill="#78B441" />
      <path d="M46.344 75.733h46.897v10.64H46.344v-10.64Z" fill="#599F40" />
      <path
        d="M82.308 74.933a.8.8 0 1 1 0 1.6H12.122a.8.8 0 1 1 0-1.6h70.186ZM96.568 80.254a.8.8 0 1 1 0 1.6H26.38a.8.8 0 1 1 0-1.6h70.187ZM22.896 80.254a.8.8 0 0 1 0 1.6h-3.17a.8.8 0 1 1 0-1.6h3.17Z"
        fill="#0F172A"
      />
      <path d="M21.628 86.374h38.658v12.83H21.628v-12.83Z" fill="#007A5F" />
      <path d="M60.286 86.374h38.659v12.83H60.286v-12.83Z" fill="#00664F" />
      <path
        d="M98.945 86.374v12.83H60.286v-12.83h38.659Zm-37.06 11.231h35.46v-9.632h-35.46v9.632Z"
        fill="#00664F"
      />
      <path
        d="M107.5 98.405a.8.8 0 1 1 0 1.6H12.122a.8.8 0 0 1 0-1.6H107.5ZM86.27 89.642a.8.8 0 0 1 0 1.6H19.727a.8.8 0 1 1 0-1.6H86.27ZM95.46 89.642a.8.8 0 0 1 0 1.6h-3.17a.8.8 0 1 1 0-1.6h3.17Z"
        fill="#0F172A"
      />
      <path d="M42.124 45.125H63.43l-3.228 10.76H38.896l3.228-10.76Z" fill="#5BBDA0" />
      <path d="M77.634 45.125H63.43l-3.228 10.76h20.66l-3.228-10.76Z" fill="#42A486" />
      <path
        d="M43.415 55.885h32.928c0 1.801-1.446 3.261-3.229 3.261h-26.47c-1.784 0-3.229-1.46-3.229-3.26Z"
        fill="#0F172A"
      />
      <path
        d="M63.753 37.625c0-2.476 1.779-4.52 3.02-6.656.546-.937.853-2 .853-3.126 0-3.782-3.468-6.848-7.747-6.848-4.28 0-7.748 3.066-7.748 6.848 0 1.13.31 2.196.859 3.136 1.243 2.13 3.015 4.173 3.015 6.646 0 6.577-6.134 7.5-6.134 7.5h20.015s-6.133-.923-6.133-7.5Z"
        fill="#A6DBCB"
      />
      <path
        d="M63.913 36.32c-.102.423-.16.857-.16 1.305 0 6.577 6.133 7.5 6.133 7.5H49.872s6.133-.923 6.133-7.5c0-.448-.058-.882-.16-1.304h8.069Z"
        fill="#A6DBCB"
      />
    </svg>
  )
}
export default wrapIllustration(SvgLawsuitMovements)
